import { useQuery } from "@tanstack/react-query";

import { logisticsApi } from "@/lib/logistics/logistics-api";
import type { ShipmentListParams, TourStatus } from "@/lib/logistics/types";

const KEY = ["logistics"] as const;

/** LOG-03 — file de préparation (paginée, triée SLA côté backend). */
export const useShipments = (params: ShipmentListParams) =>
	useQuery({
		queryKey: [...KEY, "shipments", params],
		queryFn: () => logisticsApi.shipments(params),
		staleTime: 5_000,
	});

/** LOG-06 — tournées (filtre statut). Le temps réel passe par le WebSocket. */
export const useTours = (filter: { hub?: string; status?: TourStatus } = {}) =>
	useQuery({
		queryKey: [...KEY, "tours", filter],
		queryFn: () => logisticsApi.tours(filter),
		staleTime: 10_000,
	});

export const useDrivers = (
	filter: { hub?: string; type?: string; status?: string } = {},
) =>
	useQuery({
		queryKey: [...KEY, "drivers", filter],
		queryFn: () => logisticsApi.drivers(filter),
		staleTime: 15_000,
	});

/** LOG-11 — KPI sur période sélectionnable. */
export const useLogisticsKpi = (params: {
	from?: string;
	to?: string;
	hub?: string;
}) =>
	useQuery({
		queryKey: [...KEY, "kpi", params],
		queryFn: () => logisticsApi.kpi(params),
		staleTime: 30_000,
	});

export const useHubs = () =>
	useQuery({
		queryKey: [...KEY, "hubs"],
		queryFn: () => logisticsApi.hubs(),
		staleTime: 5 * 60_000,
	});
